import LencoButton from '@/atomic-components/LencoButton';
import { getColor } from '@/utils/theme/colors';
import { TextField, InputAdornment } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { ChangeEventHandler } from 'react';
import { SelectedOffer } from '../Cart/VerticalCart';

type TOfferCodeInputProps = {
	value: string;
	onChange: (value: string) => void;
	onSubmit: () => void;
	errorMessage?: string;
	offerBeingApplied?: SelectedOffer;
};

const OfferCodeInput = (props: TOfferCodeInputProps) => {
	function onChange(e: React.ChangeEvent<HTMLInputElement>) {
		props.onChange(e.target.value);
	}

	return (
		<TextField
			fullWidth
			placeholder='Enter Coupon Code'
			id='input-offer-code'
			onChange={onChange}
			sx={{
				backgroundColor: 'none',
				'& fieldset': {
					border: 'none',
				},
				'&': {
					borderRadius: '8px',
				},
			}}
			helperText={
				props.errorMessage ? (
					<LencoTypography color={getColor('Danger +1')}>
						{props.errorMessage}
					</LencoTypography>
				) : null
			}
			InputProps={{
				sx: { background: getColor('Gray -6') },
				endAdornment: (
					<InputAdornment position='end' sx={{ mr: '8px' }}>
						<LencoButton
							variant='text'
							sx={{ color: getColor('Minty 0') }}
							onClick={props.onSubmit}
							isLoading={props.offerBeingApplied?.code == props.value}
						>
							APPLY
						</LencoButton>
					</InputAdornment>
				),
			}}
		></TextField>
	);
};

export default OfferCodeInput;
